import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { uploadPreOnboardingDocs } from '../redux/slice/preonboardingDocsUploadSlice'

const useUploadPreOnboardingDocs = () => {
  const dispatch = useDispatch();

  const handleFileUpload = async (file, type, paramId) => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    formData.append("id", paramId);

    try {

      await dispatch(uploadPreOnboardingDocs(formData)).unwrap();
      const professionalFilePrefixes = [
        'expCertFile',
        'relievingLetterFile',
        'offerLetter',
        'lastThreeMonthSalarySlip',
        'lastThreeMonthBankStatement'
      ];

      const isProfessionalFile = professionalFilePrefixes.some(prefix => type.startsWith(prefix));

      if (isProfessionalFile) {
        toast.success("File uploaded successfully!");
      } else {
        //toast.success(`${type.replaceAll(/([A-Z])/g, ' $1')} uploaded successfully!`);
        toast.success(
          `${(type.replaceAll(/([A-Z])/g, ' $1').trim())
            .replace(/^./, str => str.toUpperCase())} uploaded successfully!`
        );
      }


    } catch (error) {
      const errorMessage = error?.message || `Failed to upload ${type}`;
      toast.error(errorMessage);
    }
  };
  return ({
    handleFileUpload
  }
  )
}

export default useUploadPreOnboardingDocs;

